import React from "react";
import {Avatar, CardActionArea, DialogContent, List, Paper} from "@material-ui/core";
import EmailIcon from "@material-ui/icons/Email";
import PhoneIcon from "@material-ui/icons/Phone";
import Image from "material-ui-image/lib/components/Image/Image";
import NoMapIcon from "@material-ui/icons/ExploreOff";
import LocationIcon from "@material-ui/icons/Room";
import ContactListItem from "./ContactListItem";
import DetailListItem from "../../ListItems/DetailListItem";
import Employee from "../../../Models/Employee";
import styled from "styled-components";
import Building from "../../../Models/Building";
import openWebPage from "../../../Helper/openWebPage";

interface EmployeePageBodyProps {
    employee: Employee;
    building: Building | null;
}

const RootListContainer = styled(List)`
  height: auto;
`;

const MapSectionContainer = styled(Paper)`
  margin-top: 16px;
  margin-bottom: 16px;
  border-radius: 8px;
  overflow: hidden;
`;

const LocationIconAvatar = styled(Avatar)`
  background-color: #046a38 !important;
`;

const EmployeePageBody = (props: EmployeePageBodyProps) => {
    const {employee, building} = props;

    const onClick = (url: string) => {
        openWebPage(url)
    }

    return (
        <DialogContent
            dividers
        >
            <RootListContainer>
                <ContactListItem
                    name={employee?.fullName || ""}
                    img={employee?.imageURL || ""}
                    title={`${employee?.title || ""}\n${employee?.title_2 || ""}`}
                />
                <DetailListItem
                    title={employee?.email}
                    item={employee}
                    icon={<EmailIcon/>}
                    showDivider={true}
                    onClick={() => onClick(`mailto:${employee?.email}`)}
                    displayFavorite={false}
                />
                {employee?.phone &&
                    < DetailListItem
                        title={employee?.phone || ""}
                        item={employee}
                        showDivider={true}
                        icon={<PhoneIcon/>}
                        onClick={() => onClick(`tel:${employee?.phone}`)}
                        displayFavorite={false}
                        />
                }
                {employee?.location &&
                < DetailListItem
                    title={employee?.location}
                    icon={<LocationIcon/>}
                    showDivider={true}
                    item={employee}
                    displayFavorite={false}
                    onClick={() => onClick(building ? `maps:q=${building.coordinates}` : "")}
                    />
                }
                    {building ?
                        <MapSectionContainer
                            elevation={3}
                            component={'li'}
                        >
                            <CardActionArea
                                onClick={() => onClick(`maps:q=${building.coordinates}`)}>
                                <Image
                                    animationDuration={1000}
                                    style={{ width: '100%', paddingTop: 0}}
                                    imageStyle={{
                                        height: 'auto',
                                        position: 'relative',
                                        borderRadius: 8
                                    }}
                                    disableSpinner={true}
                                    src={building.url || ""}
                                />
                            </CardActionArea>
                        </MapSectionContainer>:
                        <DetailListItem
                            title={"NO LOCATION"}
                            item={employee}
                            icon={<NoMapIcon />}
                            displayFavorite={false}
                        />
                    }
            </RootListContainer>
        </DialogContent>
    );
};

export default EmployeePageBody;